<template>
  <button class="open-combo-icon">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 7L10 13L4 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </button>
</template>
<style scoped>
.open-combo-icon {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 20px;
  top: 32.34px;
  border: none;
  padding: 0;
  background-color: transparent;
  cursor: pointer;
}
</style>
